import "./assets/index.css";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { RequiredAuthProvider, RedirectToLogin } from "@propelauth/react";
import { ServicesProviderWrapper } from "./components/ServicesProviderWrapper";
import { Toaster } from "./components/ui/sonner";
import { TooltipProvider } from "./components/ui/tooltip";
import { AllCasesPage } from "./pages/AllCasesPage";
import { OutputDocumentPage } from "./pages/OutputDocumentPage";
import { IndividualCasePage } from "./pages/IndividualCasePage";
import { DocumentPageSummariesPage } from "./pages/DocumentPageSummariesPage";
import { DrawerProvider } from "./providers/drawer/DrawerContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { AdminCliniciansPage } from "./pages/AdminCliniciansPage";
import { SandboxConfigPage } from "./pages/SandboxConfigPage";

const container = document.getElementById("root");
const root = createRoot(container!);

export const App = () => {
  return (
    <ServicesProviderWrapper>
      <TooltipProvider delayDuration={0}>
        <DrawerProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/case/all" element={<AllCasesPage />} />
              <Route path="/case/:caseId" element={<IndividualCasePage />} />
              <Route
                path="/case/:caseId/output-document/:outputDocumentId/input-document/:inputDocumentId/summaries"
                element={<DocumentPageSummariesPage />}
              />
              <Route
                path="/case/:caseId/output-document/:documentId"
                element={<OutputDocumentPage />}
              />
              <Route
                path="/admin/clinicians"
                element={
                  <ProtectedRoute requiredRoles={["Admin"]}>
                    <AdminCliniciansPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/sandbox-config"
                element={
                  <ProtectedRoute requiredRoles={["Admin"]}>
                    <SandboxConfigPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/sandbox-config/:skillId"
                element={
                  <ProtectedRoute requiredRoles={["Admin"]}>
                    <SandboxConfigPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/physician/sandbox-skills"
                element={<SandboxConfigPage />}
              />
              <Route
                path="/physician/sandbox-skills/:skillId"
                element={<SandboxConfigPage />}
              />
              <Route path="/" element={<Navigate to="/case/all" replace />} />
            </Routes>
            <Toaster richColors />
          </BrowserRouter>
        </DrawerProvider>
      </TooltipProvider>
    </ServicesProviderWrapper>
  );
};

const authUrl = import.meta.env.VITE_AUTH_URL;

root.render(
  <RequiredAuthProvider
    authUrl={authUrl}
    displayIfLoggedOut={
      <RedirectToLogin postLoginRedirectUrl={window.location.href} />
    }
  >
    <App />
  </RequiredAuthProvider>
);
